import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Htopbar() {
  const userState = useSelector((state) => state?.auth);
  const [currentPromo, setCurrentPromo] = useState(0);

  const promos = [
    {
      text: "💊 15% OFF All Prescriptions — Limited Time!",
      link: "/prescription",
    },
    { text: "🚚 Free Delivery on Orders Over 2,000 ETB", link: "/shop" },
    { text: "✨ New OTC Medicines & Vitamins Just In!", link: "/new" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPromo((prev) => (prev + 1) % promos.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [promos.length]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <>
      <style>{`
        /* ===== Container ===== */
        .htb-header {
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
          color: #1e293b;
          position: relative;
          z-index: 1001;
        }

        .htb-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 16px;
        }

        .htb-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 36px;
          gap: 12px;
        }

        /* ===== Left: Promo Carousel ===== */
        .htb-promo {
          display: none;
          flex: 1;
        }

        @media (min-width: 768px) {
          .htb-promo {
            display: flex;
            align-items: center;
          }
        }

        .htb-promo-link {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #0d9488;
          text-decoration: none;
          font-size: 10.5px;
          font-weight: 800;
          letter-spacing: 0.1px;
          transition: all 0.2s ease;
          text-transform: uppercase;
        }

        .htb-promo-link:hover {
          color: #0f766e;
          transform: translateX(2px);
        }

        .htb-promo-dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #14b8a6;
          animation: htbPulse 2s ease-in-out infinite;
        }

        @keyframes htbPulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.6); }
        }

        /* ===== Account Links ===== */
        .htb-account-list {
          display: flex;
          align-items: center;
          gap: 0;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .htb-account-link {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 4px 10px;
          font-size: 10.5px;
          font-weight: 700;
          color: #64748b;
          text-decoration: none;
          transition: all 0.2s ease;
          border-radius: 4px;
        }

        .htb-account-link:hover {
          color: #14b8a6;
          background: #f1f5f9;
        }

        .htb-icon {
          font-size: 12px;
          opacity: 0.8;
        }

        .htb-link-divider {
          width: 1px;
          height: 12px;
          background: #e2e8f0;
          margin: 0 4px;
        }

        .htb-logout-btn {
          color: #ef4444;
          background: transparent;
          border: none;
          font-weight: 700;
          font-size: 10.5px;
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
          padding: 4px 8px;
          border-radius: 4px;
        }

        .htb-logout-btn:hover {
          background: #fef2f2;
        }

        @media (max-width: 768px) { 
          .htb-mobile-promo { display: block; }
          .htb-inner { display: none !important; }
        }
        @media (min-width: 768px) { .htb-mobile-promo { display: none; } }

        .htb-mobile-promo-link {
          font-size: 9.5px;
          font-weight: 800;
          color: #0d9488;
          text-decoration: none;
          text-transform: uppercase;
        }
      `}</style>

      <header className="htb-header">
        <div className="htb-container">
          {/* Mobile promo ticker */}
          <div className="htb-mobile-promo">
            <p className="htb-mobile-promo-text" key={currentPromo}>
              <Link
                to={promos[currentPromo].link}
                className="htb-mobile-promo-link"
              >
                {promos[currentPromo].text}
              </Link>
            </p>
          </div>

          <div className="htb-inner">
            {/* Left: Promo Carousel (Now Centered) */}
            <div className="htb-promo flex-1 flex justify-center">
              <div className="flex items-center">
                <Link
                  to={promos[currentPromo].link}
                  className="htb-promo-link"
                  key={currentPromo}
                >
                  <span className="htb-promo-dot" />
                  {promos[currentPromo].text}
                </Link>
                <div className="htb-promo-indicators">
                  {promos.map((_, index) => (
                    <button
                      key={index}
                      className={`htb-indicator ${index === currentPromo ? "active" : ""}`}
                      onClick={() => setCurrentPromo(index)}
                      aria-label={`Promo ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Account Links */}
            <div className="htb-account flex-shrink-0">
              <ul className="htb-account-list">
                {userState?.user ? (
                  <>
                    <li>
                      <Link className="htb-account-link" to="/myaccount">
                        <span className="htb-icon">👤</span>
                        My Account
                      </Link>
                    </li>
                    <li>
                      <span className="htb-link-divider" />
                    </li>
                    <li>
                      <button
                        onClick={handleLogout}
                        className="htb-account-btn htb-logout-btn"
                      >
                        <span className="htb-icon">🚪</span>
                        Logout
                      </button>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <Link className="htb-account-link" to="/register">
                        <span className="htb-icon">📝</span>
                        Register
                      </Link>
                    </li>
                    <li>
                      <span className="htb-link-divider" />
                    </li>
                    <li>
                      <Link className="htb-account-link" to="/login">
                        <span className="htb-icon">🔓</span>
                        Login
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Htopbar;
